/* eslint-disable react/require-default-props */

import React from "react";
import { RouteProps as ReactDOMRouterProps, Navigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";

interface RouteProps<T = any> {
  component: React.ReactElement<T>;
  onlyAdmin?: boolean;
}

const PrivateRoute: React.FC<RouteProps> = ({
  component: Component,
  onlyAdmin = false
}) => {
  const { user } = useAuth();

  if (onlyAdmin && user) {
    return user.admin ? Component : <Navigate to="/" />;
  }

  return user ? Component : <Navigate to="/login" />;
};

export default PrivateRoute;
